import type { ExternalTableSchema, SectionDef } from './types';

export const SCHEMA_VERSION = '2.0' as const;

export function isV2Schema(schema: any): boolean {
  if (!schema || !schema.columns || !Array.isArray(schema.columns)) return false;
  if (schema.columns.length === 0) return false;
  const firstCol = schema.columns[0];
  return typeof firstCol.field === 'string' && !firstCol.Header && !firstCol.accessor;
}

export function isV1Schema(schema: any): boolean {
  if (!schema || !schema.columns || !Array.isArray(schema.columns)) return false;
  if (schema.columns.length === 0) return false;
  const firstCol = schema.columns[0];
  return typeof firstCol.Header === 'string' || typeof firstCol.accessor === 'string';
}

export function isMultiSectionSchema(
  schema: unknown,
): schema is ExternalTableSchema & { sections: SectionDef[] } {
  return (
    typeof schema === 'object' &&
    schema !== null &&
    'sections' in schema &&
    Array.isArray((schema as Record<string, unknown>).sections) &&
    ((schema as Record<string, unknown>).sections as unknown[]).length > 0
  );
}
